/**
 * Responses from guest / API access token endpoints (session-scoped or client-key).
 */
export interface SessionTokenResponse {
  token: string;
  expEpochSecond?: number;
}

export interface ClientApiTokenResponse {
  token?: string;
  accessToken?: string;
  apiToken?: string;
  expEpochSecond?: number;
}

export function tokenFromApiAccessBody(
  body: SessionTokenResponse | ClientApiTokenResponse | null | undefined
): string | null {
  if (!body) {
    return null;
  }
  const b = body as Record<string, string | number | undefined>;
  const t = b['token'] ?? b['accessToken'] ?? b['apiToken'];
  return typeof t === 'string' ? t : null;
}
